 <app-type-voie  [uid]="getUid()" [parentForm]="parentForm" [voie]="lieuLivraison.voie"
 [rule]="rule" [errorMessage]="errorMessage"></app-type-voie>

 <app-form-input 
 [parentForm]="parentForm" 
 [value]="lieuLivraison.cp" 
  
 [label]="step3.getcp"
 [type]="'text'" 
 [rule]="'pattern_3'"
 [errorMessage]="errorMessage"
 [name]="getUid()+'_SepAtt_cp'">
 </app-form-input>

<app-form-input 
[parentForm]="parentForm" 
[value]="lieuLivraison.ville" 
 
[label]="step3.getville"
[type]="'text'" [rule]="'minSize_1|maxSize_100'"
[name]="getUid()+'_SepAtt_ville'">
</app-form-input>